const EMAIL_VISUALS = [
  {
    id: 1,
    name: 'Morning Momentum',
    href: '#',
    imageSrc: '/images/AM-p-500.png',
    imageAlt: 'Morning Momentum',
  },
  {
    id: 2,
    name: 'Mid-day Movers',
    href: '#',
    imageSrc: '/images/AM-p1-500.png',
    imageAlt: 'Mid-day Movers',
  },
  {
    id: 3,
    name: 'Daily Recap',
    href: '#',
    imageSrc: '/images/AM-p2-500.png',
    imageAlt: 'Daily Recap',
  },
  {
    id: 4,
    name: 'Weekly Recap',
    href: '#',
    imageSrc: '/images/AM-p3-500.png',
    imageAlt: 'Weekly Recap',
  },
];

const EmailVisuals = () => {
  return (
    <div className="mx-auto max-w-2xl px-4 pt-5 pb-16 sm:px-6 lg:max-w-7xl lg:px-8">
      <div className="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-8">
        {EMAIL_VISUALS.map((items) => (
          <div key={items.id} className="group relative">
            <h3 className="mb-3 px-5 text-center text-[22px] text-white">{items.name}</h3>
            <div className="aspect-h-1 aspect-w-1 lg:aspect-none w-full overflow-hidden rounded-md bg-gray-200 group-hover:opacity-75 lg:h-80">
              <img
                src={items.imageSrc}
                alt={items.imageAlt}
                className="h-full w-full object-cover object-center lg:h-full lg:w-full"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmailVisuals;
